/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Comment } from './Comment';
import {
    CommentFromJSON,
    CommentFromJSONTyped,
    CommentToJSON,
} from './Comment';
import type { EntryGroup } from './EntryGroup';
import {
    EntryGroupFromJSON,
    EntryGroupFromJSONTyped,
    EntryGroupToJSON,
} from './EntryGroup';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { SAPAttachment } from './SAPAttachment';
import {
    SAPAttachmentFromJSON,
    SAPAttachmentFromJSONTyped,
    SAPAttachmentToJSON,
} from './SAPAttachment';

/**
 * Representation of the quote object.
 * @export
 * @interface Quote
 */
export interface Quote {
    /**
     * Expiration time of the quote.
     * @type {Date}
     * @memberof Quote
     */
    expirationTime: Date;
    /**
     * Code of the quote.
     * @type {string}
     * @memberof Quote
     */
    code: string;
    /**
     * Name of the quote.
     * @type {string}
     * @memberof Quote
     */
    name: string;
    /**
     * Current state of the quote. Possible state values - DRAFT, SUBMITTED, OFFER, CANCELLED, EXPIRED, etc.. The list of the states can be extended.
     * @type {string}
     * @memberof Quote
     */
    state: string;
    /**
     * Description of the quote.
     * @type {string}
     * @memberof Quote
     */
    description?: string;
    /**
     * Current version of the quote.
     * @type {number}
     * @memberof Quote
     */
    version: number;
    /**
     * Minimum subtotal value for the quote in the currency of the store.
     * @type {number}
     * @memberof Quote
     */
    threshold: number;
    /**
     * Id of the cart, which is linked to the quote.
     * @type {string}
     * @memberof Quote
     */
    cartId?: string;
    /**
     * Date of quote creation.
     * @type {Date}
     * @memberof Quote
     */
    creationTime: Date;
    /**
     * Date of the last quote update.
     * @type {Date}
     * @memberof Quote
     */
    updatedTime: Date;
    /**
     * Actions, which are allowed to perform with the quote.
     * @type {Array<string>}
     * @memberof Quote
     */
    allowedActions?: Array<string>;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    previousEstimatedTotal?: Price;
    /**
     * List of quote comments.
     * @type {Array<Comment>}
     * @memberof Quote
     */
    comments?: Array<Comment>;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    totalPriceWithTax?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    totalPrice?: Price;
    /**
     * Entries of the cart.
     * @type {Array<OrderEntry>}
     * @memberof Quote
     */
    entries?: Array<OrderEntry>;
    /**
     * List of entry groups
     * @type {Array<EntryGroup>}
     * @memberof Quote
     */
    entryGroups?: Array<EntryGroup>;
    /**
     * Total number of the items in the quote.
     * @type {number}
     * @memberof Quote
     */
    totalItems: number;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    quoteDiscounts?: Price;
    /**
     * Value of the discount
     * @type {number}
     * @memberof Quote
     */
    sapQuoteDiscountsRate?: number;
    /**
     * Type of the discount - PERCENT for discount by percentage, ABSOLUTE for discount by amount, TARGET for discount by adjustment of the total value
     * @type {string}
     * @memberof Quote
     */
    sapQuoteDiscountsType?: string;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    orderDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    subTotalWithDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    productDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof Quote
     */
    sapSubtotalExcludingOrderLevelDiscount?: Price;
    /**
     * List of SAP attachments
     * @type {Array<SAPAttachment>}
     * @memberof Quote
     */
    sapAttachments?: Array<SAPAttachment>;
    /**
     * Order Code associated with the Quote. The Order Code is present if the quote was used to place an order.
     * @type {string}
     * @memberof Quote
     */
    sapOrderCode?: string;
    /**
     * Purchase Order Number
     * @type {string}
     * @memberof Quote
     */
    sapPurchaseOrderNumber?: string;
}

/**
 * Check if a given object implements the Quote interface.
 */
export function instanceOfQuote(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "expirationTime" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "threshold" in value;
    isInstance = isInstance && "creationTime" in value;
    isInstance = isInstance && "updatedTime" in value;
    isInstance = isInstance && "totalItems" in value;

    return isInstance;
}

export function QuoteFromJSON(json: any): Quote {
    return QuoteFromJSONTyped(json, false);
}

export function QuoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Quote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expirationTime': (new Date(json['expirationTime'])),
        'code': json['code'],
        'name': json['name'],
        'state': json['state'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'version': json['version'],
        'threshold': json['threshold'],
        'cartId': !exists(json, 'cartId') ? undefined : json['cartId'],
        'creationTime': (new Date(json['creationTime'])),
        'updatedTime': (new Date(json['updatedTime'])),
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'previousEstimatedTotal': !exists(json, 'previousEstimatedTotal') ? undefined : PriceFromJSON(json['previousEstimatedTotal']),
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(CommentFromJSON)),
        'totalPriceWithTax': !exists(json, 'totalPriceWithTax') ? undefined : PriceFromJSON(json['totalPriceWithTax']),
        'totalPrice': !exists(json, 'totalPrice') ? undefined : PriceFromJSON(json['totalPrice']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(OrderEntryFromJSON)),
        'entryGroups': !exists(json, 'entryGroups') ? undefined : ((json['entryGroups'] as Array<any>).map(EntryGroupFromJSON)),
        'totalItems': json['totalItems'],
        'quoteDiscounts': !exists(json, 'quoteDiscounts') ? undefined : PriceFromJSON(json['quoteDiscounts']),
        'sapQuoteDiscountsRate': !exists(json, 'sapQuoteDiscountsRate') ? undefined : json['sapQuoteDiscountsRate'],
        'sapQuoteDiscountsType': !exists(json, 'sapQuoteDiscountsType') ? undefined : json['sapQuoteDiscountsType'],
        'orderDiscounts': !exists(json, 'orderDiscounts') ? undefined : PriceFromJSON(json['orderDiscounts']),
        'subTotalWithDiscounts': !exists(json, 'subTotalWithDiscounts') ? undefined : PriceFromJSON(json['subTotalWithDiscounts']),
        'productDiscounts': !exists(json, 'productDiscounts') ? undefined : PriceFromJSON(json['productDiscounts']),
        'sapSubtotalExcludingOrderLevelDiscount': !exists(json, 'sapSubtotalExcludingOrderLevelDiscount') ? undefined : PriceFromJSON(json['sapSubtotalExcludingOrderLevelDiscount']),
        'sapAttachments': !exists(json, 'sapAttachments') ? undefined : ((json['sapAttachments'] as Array<any>).map(SAPAttachmentFromJSON)),
        'sapOrderCode': !exists(json, 'sapOrderCode') ? undefined : json['sapOrderCode'],
        'sapPurchaseOrderNumber': !exists(json, 'sapPurchaseOrderNumber') ? undefined : json['sapPurchaseOrderNumber'],
    };
}

export function QuoteToJSON(value?: Quote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expirationTime': (value.expirationTime.toISOString()),
        'code': value.code,
        'name': value.name,
        'state': value.state,
        'description': value.description,
        'version': value.version,
        'threshold': value.threshold,
        'cartId': value.cartId,
        'creationTime': (value.creationTime.toISOString()),
        'updatedTime': (value.updatedTime.toISOString()),
        'allowedActions': value.allowedActions,
        'previousEstimatedTotal': PriceToJSON(value.previousEstimatedTotal),
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(CommentToJSON)),
        'totalPriceWithTax': PriceToJSON(value.totalPriceWithTax),
        'totalPrice': PriceToJSON(value.totalPrice),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(OrderEntryToJSON)),
        'entryGroups': value.entryGroups === undefined ? undefined : ((value.entryGroups as Array<any>).map(EntryGroupToJSON)),
        'totalItems': value.totalItems,
        'quoteDiscounts': PriceToJSON(value.quoteDiscounts),
        'sapQuoteDiscountsRate': value.sapQuoteDiscountsRate,
        'sapQuoteDiscountsType': value.sapQuoteDiscountsType,
        'orderDiscounts': PriceToJSON(value.orderDiscounts),
        'subTotalWithDiscounts': PriceToJSON(value.subTotalWithDiscounts),
        'productDiscounts': PriceToJSON(value.productDiscounts),
        'sapSubtotalExcludingOrderLevelDiscount': PriceToJSON(value.sapSubtotalExcludingOrderLevelDiscount),
        'sapAttachments': value.sapAttachments === undefined ? undefined : ((value.sapAttachments as Array<any>).map(SAPAttachmentToJSON)),
        'sapOrderCode': value.sapOrderCode,
        'sapPurchaseOrderNumber': value.sapPurchaseOrderNumber,
    };
}

